import { IResolution } from './IResolutionsManager';

// eslint-disable-next-line @typescript-eslint/typedef
export const ResolutionsManagerEvents = {
  resolutionsAvailable: 'resolutionsManager.resolutionsAvailable',
  reportCurrentResolution: 'resolutionManager.reportCurrentResolution',
  resolutionChanged: 'resolutionManager.resolutionChanged',
  resolutionCodecAvailable: 'resolutionManager.resolutionChanged',
  resolutionAutoChanged: 'resolutionManager.resolutionAutoChanged',
  requestResolutionChange: 'resolutionManager.requestResolutionChange',
  requestRestartFromMain: 'resolutionManager.requestRestartFromMain',
  resolutionNotFound: 'resolutionManager.resolutionNotFound',
  resolutionsMaximumAvailable: 'resolutionManager.resolutionsMaximumAvailable',
  entrypointURLUpdated: 'resolutionManager.entrypointURLUpdated',
} as const;

export type TResolutionsManagerEvents = {
  [ResolutionsManagerEvents.resolutionsAvailable]: IResolution[];
  [ResolutionsManagerEvents.resolutionsMaximumAvailable]: IResolution;
  [ResolutionsManagerEvents.resolutionChanged]: IResolution;
};
